import { render, staticRenderFns } from "./BannerHome.vue?vue&type=template&id=52bd291c"
import script from "./BannerHome.vue?vue&type=script&lang=js"
export * from "./BannerHome.vue?vue&type=script&lang=js"
import style0 from "./BannerHome.vue?vue&type=style&index=0&id=52bd291c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports